import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { chatActions, propertyActions, settingsActions } from '_actions';
import styled from 'styled-components';
import Messages from './List/Messages.List';
import Quicklinks from './List/Quicklinks.List';
import Specials from './List/Specials.List';
import Input from './Utility/Input';
import { useDebouncedCallback } from 'use-debounce';

const ConversationWrapper = styled.div`
  width: 100%;
  overflow: visible;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
  z-index: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -ms-flex-direction: column;
  flex-direction: column;
  position: relative;
  height: auto;
  padding-bottom: 34px;

  .BotMessageWrapper:nth-child(1) {
    margin-top: 0;
  }

  padding-top: 83px;

  @media screen and (min-width: ${(prop) =>
    prop.theme.screenSizes.breakSmall}) {
    padding-top: 84px;
  }

  @media screen and (min-width: ${(prop) =>
    prop.theme.screenSizes.breakLaptop}) {
    padding-top: 80px;
  }
`;

const WithInput = styled.div`
 
  padding-top: 20px !important;
  padding-bottom: 70px !important;
 
`;
const MessagesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 18px;
  padding-left: 18px;

  @media screen and (min-width: ${(prop) =>
    prop.theme.screenSizes.breakSmall}) {
    padding-right: 18px;
    padding-left: 18px;

    ${({ typing }) =>
    typing &&
    `
      // padding-bottom: 34px !important;
    `}
  }
  @media screen and (min-width: ${(prop) =>
    prop.theme.screenSizes.breakLaptop}) {
    padding: 0 52px 0 51px;
  }
`;

function Conversation(props) {
  const {
    getData,
    setDefaultSettings,
    interactions,
    sendMessage,
    tid,
    userId,
    language,
    shouldScroll,
    location, // this is a prop from react router
    setScroll,
    match,
    typing,
    inputVisible,
    setRentgrata,
    chatGPT,
    logVisitor,
  } = props;

  // Ref to bottom of the messages
  const messagesEndRef = useRef(null);

  /**
   * Setup default info
   * Once tid is present, send the first message
   * This only executes if tid is changed and we don't have that option
   */
  useEffect(() => {
    function setup(tid) {
      if (!tid) {
        getData();
        setDefaultSettings(location['search']);
        logVisitor();
      } else {
        if (userId) {
          sendMessage(
            {
              text: '',
              value: match.params.intent || 'heartbeat',
              gaEvent: 'Start Conversation'
            },
            'text',
          );
        }
      }
    }

    setup(tid);
  }, [userId]);

  /**
   * Debounced scroll to bottom function
   * it is a ref that is at the bottom of the whole conversation container
   */
  const debouncedScrollToBottom = useDebouncedCallback((behavior) => {
    if (window.matchMedia("(min-width: 1024px) and (max-width: 1366px) and (min-height: 1366px)").matches) {
      messagesEndRef.current.scrollIntoView(true);
      /** The problem with the automatic scroll was only on iPad Pro resolution, hence the if statement */
    }
    else {
      messagesEndRef.current.scrollIntoView({ behavior: behavior });
    }
  }, 100);
  useEffect(() => {
    if (interactions === 1) {
      window.parent.postMessage(
        { message: 'pull prospect data', userId: userId },
        '*',
      );
    }
  }, [interactions]);

  useEffect(() => {
    if (shouldScroll) {
      debouncedScrollToBottom(shouldScroll);
      setScroll(false);
    }
  }, [shouldScroll]);

  // Use debounced effect on resize (will execute only when you stop resizing)
  useEffect(() => {
    window.addEventListener('resize', () => debouncedScrollToBottom('smooth'));
    window.parent.postMessage("check-rentgrata-availability", "*");

    window.addEventListener("message", (e) => {
      if (e.data == 'rentgrata-available') {
        setRentgrata(true);
      }
      if (e.data == 'scroll to bottom') {
        debouncedScrollToBottom('smooth');
      }
    });


    return () => {
      window.removeEventListener("message");
      window.removeEventListener("resize", () => debouncedScrollToBottom('smooth'));
    };
  }, []);

  useEffect(() => {
    if (interactions === 1) {
      window.parent.postMessage({ message: "pull prospect data", id: userId }, "*");
    }
  }, [interactions])

  return (
    <>
      {tid && (
        <>
          <ConversationWrapper className="ConversationWrapper messages">
            <MessagesWrapper className="MessagesWrapper" typing={typing}>
              <Messages />
            </MessagesWrapper>
            <Specials />

            {
              chatGPT.type=='chatgpt' ?
                (<>
                <WithInput className="WithInput">
                  <Quicklinks/>
                  </WithInput>
                </>) : (
                  inputVisible ? (
                    <>
                      <Input />
                      <Quicklinks />
                    </>
                  ) : (
                    <Quicklinks />
                  ))}

            <div ref={messagesEndRef} />
          </ConversationWrapper>
        </>
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  inIframe: state.settings.inIframe,
  tid: state.settings.tid,
  userId: state.settings.userId,
  chatGPT: state.chat.input,
  interactions: state.chat.interactions,
  language: state.settings.language,
  shouldScroll: state.settings.scroll,
  typing: state.chat.typing,
  inputVisible: state.chat.input.visible,
});

const actions = {
  getData: propertyActions.get,
  setDefaultSettings: settingsActions.setDefault,
  sendMessage: chatActions.send,
  setScroll: settingsActions.setScroll,
  setRentgrata: settingsActions.setRentgrata,
  logVisitor: settingsActions.logVisitor,
};

export default connect(mapStateToProps, actions)(Conversation);
